"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
Object.defineProperty(exports, "BasicStrategy", {
    enumerable: true,
    get: function() {
        return BasicStrategy;
    }
});
const _passporthttp = require("passport-http");
const _common = require("@nestjs/common");
const _passport = require("@nestjs/passport");
const _config = require("@nestjs/config");
const _ncError = require("~/helpers/ncError");
function _ts_decorate(decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for(var i = decorators.length - 1; i >= 0; i--)if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
}
function _ts_metadata(k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
}
let BasicStrategy = class BasicStrategy extends (0, _passport.PassportStrategy)(_passporthttp.BasicStrategy) {
    constructor(configService){
        super({
            passReqToCallback: true
        }), this.configService = configService, this.validate = async (req, username, password)=>{
            const credentials = this.configService.get('basicAuth', {
                infer: true
            });
            if (credentials.username === username && credentials.password === password) {
                return true;
            }
            _ncError.NcError.unauthorized('UnAuthorized');
        };
    }
};
BasicStrategy = _ts_decorate([
    (0, _common.Injectable)(),
    _ts_metadata("design:type", Function),
    _ts_metadata("design:paramtypes", [
        typeof _config.ConfigService === "undefined" ? Object : _config.ConfigService
    ])
], BasicStrategy);
